import React from 'react';

export const EnterIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_15176_6884)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.8 0V4H0V0H12.8ZM8.576 6.4L12.8 16H8.532L6.4 10.4L4.268 16H0L4.224 6.4H8.576Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_15176_6884">
          <rect width="12.8" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
